const i18nConfig = {
  defaultLocale: 'en', // en -> gb
  locales: [
    'en',
    'de',
    //'au',
    'at',
    'be',
    'cz',
    'dk',
    'fi',
    'fr',
    'hu',
    'is',
    'ie',
    'it',
    'lu',
    'nl',
    //'nz',
    'pl',
    'pt',
    'sk',
    'es',
    'se',
    'ch',
  ], // en -> gb
};

export default i18nConfig;
